import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CheckIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={14} height={14} viewBox="0 0 256 256" {...props}>
      <path fill="currentColor"
            d="m232.49 80.49l-128 128a12 12 0 0 1-17 0l-56-56a12 12 0 1 1 17-17L96 183L215.51 63.51a12 12 0 0 1 17 17Z"/>
    </SvgIcon>
  );
};

